module.exports = __webpack_public_path__ + "static/media/comments_active.80c2d966.svg";